import React from "react";
import {
  createStyles,
  Header,
  Group,
  Text,
  Divider,
  Box,
  Burger,
  Drawer,
  ScrollArea,
  rem,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

const useStyles = createStyles((theme) => ({
  link: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    textDecoration: "none",
    color: "#e27130",
    fontSize: theme.fontSizes.md,

    [theme.fn.smallerThan("sm")]: {
      height: rem(42),
      display: "flex",
      alignItems: "center",
      color: "#e27130",
    },
  },

  subLink: {
    width: "100%",
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,
    borderRadius: theme.radius.md,

    "&:active": theme.activeStyles,
  },

  dropdownFooter: {
    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.dark[7]
        : theme.colors.gray[0],
    margin: `calc(${theme.spacing.md} * -1)`,
    marginTop: theme.spacing.sm,
    padding: `${theme.spacing.md} calc(${theme.spacing.md} * 2)`,
    paddingBottom: theme.spacing.xl,
    borderTop: `${rem(1)} solid ${
      theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]
    }`,
  },

  header: {
    borderBottom: 0,
  },

  hiddenMobile: {
    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  hiddenDesktop: {
    [theme.fn.largerThan("sm")]: {
      display: "none",
    },
  },

  // a:hover {
  //   color: rgb(141, 107, 85);
  // }

  // a {
  //   color: #9b9974;
  // }

  titlelink: {
    color: "#e27130",
    display: "flex",
    alignItems: "center",
    height: "100%",
    paddingLeft: rem(8),
    paddingRight: theme.spacing.md,
    textDecoration: "none",
    fontSize: rem(24),

    [theme.fn.smallerThan("sm")]: {
      color: "#e27130",
      height: rem(42),
      display: "flex",
      alignItems: "center",
      fontSize: rem(15),
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
  },
}));

export function HeaderNav() {
  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] =
    useDisclosure(false);
  const { classes, theme } = useStyles();

  return (
    <Box className="noselect">
      <Header
        className={classes.header}
        sx={{ borderBottom: "1px solid #e27130" }}
        height={60}
        px="md"
      >
        <Group position="apart" sx={{ height: "100%", flexWrap: "nowrap" }}>
          <Text fw={500} size={50} style={{ minWidth: 0, overflow: "hidden" }}>
            <a href="../" className={classes.titlelink}>
              {"amma & mamman's stamp book"}
            </a>
          </Text>
          <Group
            sx={{ height: "100%" }}
            spacing={0}
            className={classes.hiddenMobile}
          >
            <a href="../about" className={classes.link}>
              about
            </a>
          </Group>
          <Burger
            color="#9b9974"
            size="sm"
            opened={drawerOpened}
            onClick={toggleDrawer}
            className={classes.hiddenDesktop}
          />
        </Group>
      </Header>

      <Drawer
        opened={drawerOpened}
        onClose={closeDrawer}
        size="100%"
        padding="md"
        zIndex={1000000}
      >
        <ScrollArea h={`calc(100vh - ${rem(60)})`} mx="-md">
          <Text size="xl">
            <a href="../" className={classes.titlelink}>
              amma & mamman's stamp book
            </a>
          </Text>
          <Divider
            my="sm"
            color={theme.colorScheme === "dark" ? "dark.5" : "gray.1"}
          />

          <Text size="sm">
            <a href="../about" className={classes.link}>
              about
            </a>
          </Text>

          <Divider
            my="sm"
            color={theme.colorScheme === "dark" ? "dark.5" : "gray.1"}
          />
        </ScrollArea>
      </Drawer>
    </Box>
  );
}
